import { common } from './common';

export const ko = {
  common,
};